import React from 'react';
import PropTypes from 'prop-types';
import { Route, Redirect } from 'react-router-dom';

import api from '~/services/api';
import history from '~/services/history';

import AuthLayout from '~/pages/_layouts/auth';
import DefaultLayout from '~/pages/_layouts/default';

import { store } from '~/store';

async function checkUserAdmin() {
  const userId = store.getState().user.profile.id;
  const response = await api.get(`users/${userId}`);
  return response.data.admin;
}

export default function RouteWrapper({
  component: Component,
  isPrivate,
  onlyAdmin,
  ...rest
}) {
  const { signed } = store.getState().auth;

  if (!signed && isPrivate) {
    return <Redirect to="/" />;
  }

  if (signed && !isPrivate) {
    return <Redirect to="/dashboard" />;
  }

  if (signed && onlyAdmin) {
    checkUserAdmin().then(admin => {
      if (!admin) {
        history.push('/dashboard');
      }
    });
  }

  const Layout = signed ? DefaultLayout : AuthLayout;

  return (
    <Route
      {...rest}
      render={props => (
        <Layout>
          <Component {...props} />
        </Layout>
      )}
    />
  );
}

RouteWrapper.propTypes = {
  isPrivate: PropTypes.bool,
  onlyAdmin: PropTypes.bool,
  component: PropTypes.oneOfType([PropTypes.element, PropTypes.func])
    .isRequired,
};

RouteWrapper.defaultProps = {
  isPrivate: false,
  onlyAdmin: false,
};
